var React = require('react');

function ArrowIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m5.39823.343112c-.04824-.055377-.10827-.099797-.17591-.130156s-.14125-.045925-.21568-.045608h-4.413835c-.097625-.000034-.193218.027235-.275478.078585-.082261.051349-.147748.124631-.18872.211182-.0409718.086551-.0557147.18275-.0424856.277226.0132291.094475.0538766.183275.1171376.255901l4.505851 5.169058-4.505851 5.1691c-.063261.0726-.1039085.1614-.1171376.2559-.0132291.0944.0015138.1906.0424856.2772.040972.0865.106459.1598.18872.2112.08226.0513.177853.0786.275478.0785h4.413835c.07409.0001.1473-.0156.21456-.046.06727-.0303.12697-.0746.17498-.1297l4.78802-5.49264c.0787-.0903.1219-.205.1219-.32356 0-.11857-.0432-.23327-.1219-.32357z"}));
}

ArrowIconInline.defaultProps = {"fill":"none","height":"13","viewBox":"0 0 11 13","width":"11"};

module.exports = ArrowIconInline;

ArrowIconInline.default = ArrowIconInline;
